let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("br9SP")).then(() => parcelRequire('72OPL'));